import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Section = ({ title, children }) => (
  <Box style={{ marginBottom: '28px' }}>
    <Typography variant="h6" style={{ marginBottom: '8px' }}>{title}</Typography>
    {children}
  </Box>
);

const P = ({ children, style }) => (
  <Typography style={{ lineHeight: '1.8', marginTop: '6px', ...style }}>{children}</Typography>
);

const Datenschutzerklaerung = () => {
  return (
    <Container style={{ padding: '40px', maxWidth: '800px' }}>
      <Typography variant="h4" align="center" gutterBottom>
        Datenschutzerklärung
      </Typography>

      <Box style={{ marginBottom: '28px' }}>
        <P>
          Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen.
          Nachfolgend informieren wir Sie gemäß Art. 13 DSGVO darüber, wie auf dieser
          Website mit Ihren Daten umgegangen wird.
        </P>
      </Box>

      <Section title="1. Verantwortlicher für die Datenverarbeitung">
        <P>
          <strong>Sylwia Spiller</strong><br />
          Riemeisterstraße 39 a, 14169 Berlin<br />
          Telefon: +49 15560 759736<br />
          E-Mail: kontakt@heilpraxis-spiller.de
        </P>
      </Section>

      <Section title="2. Allgemeines zur Datenverarbeitung">
        <P>
          Wir verwenden keine Tracking-Tools, Analyse-Software oder Cookies und
          speichern keine IP-Adressen. Personenbezogene Daten werden auf dieser
          Website ausschließlich dann erhoben, wenn Sie uns über das Kontaktformular
          eine Nachricht senden (siehe Abschnitt 3).
        </P>
      </Section>

      <Section title="3. Kontaktformular (EmailJS)">
        <P>
          Wenn Sie unser Kontaktformular nutzen, erheben und verarbeiten wir die
          folgenden Daten:
        </P>
        <P>
          • Name<br />
          • E-Mail-Adresse<br />
          • Telefonnummer (optional)<br />
          • Ihre Nachricht
        </P>
        <P>
          <strong>Zweck:</strong> Bearbeitung Ihrer Anfrage und Kontaktaufnahme.
        </P>
        <P>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung)
          sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung
          von Anfragen).
        </P>
        <P>
          <strong>Dienstleister – EmailJS:</strong> Zur technischen Übermittlung des
          Formulars nutzen wir den Dienst EmailJS (Impression Group LLC, USA). Die
          eingegebenen Daten werden dabei über die Server von EmailJS an unsere
          E-Mail-Adresse weitergeleitet. EmailJS speichert die Formulardaten nicht
          dauerhaft; sie dienen ausschließlich der Weiterleitung. Die Datenverarbeitung
          erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Weitere Informationen
          finden Sie in der Datenschutzerklärung von EmailJS:{' '}
          <a
            href="https://www.emailjs.com/legal/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#2E7D32' }}
          >
            emailjs.com/legal/privacy-policy
          </a>
        </P>
        <P>
          <strong>Drittlandübermittlung:</strong> Da EmailJS ein US-amerikanischer
          Anbieter ist, können Daten in die USA übertragen werden. EmailJS stützt
          sich dabei auf Standardvertragsklauseln gemäß Art. 46 DSGVO.
        </P>
        <P>
          <strong>Speicherdauer:</strong> Ihre Daten werden nur so lange gespeichert,
          wie es für die Bearbeitung Ihrer Anfrage erforderlich ist. E-Mails werden
          gelöscht, sobald sie nicht mehr benötigt werden, spätestens nach 3 Jahren.
        </P>
        <P>
          <strong>Alternativer Kontaktweg:</strong> Sie können uns auch direkt per
          E-Mail (kontakt@heilpraxis-spiller.de) oder telefonisch kontaktieren,
          ohne das Formular zu nutzen.
        </P>
      </Section>

      <Section title="4. Bereitstellung der Website (Azure Static Web Apps)">
        <P>
          Diese Website wird über Microsoft Azure Static Web Apps (Microsoft Corporation,
          USA) gehostet. Beim Aufruf der Website können technisch bedingt temporäre
          Verbindungsdaten wie IP-Adressen kurzzeitig in Server-Logs erfasst werden.
          Dies geschieht auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
          Interesse am sicheren Betrieb der Website) und liegt im Verantwortungsbereich
          von Microsoft. Weitere Informationen:{' '}
          <a
            href="https://privacy.microsoft.com/de-de/privacystatement"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#2E7D32' }}
          >
            Microsoft Datenschutzerklärung
          </a>
        </P>
      </Section>

      <Section title="5. Externe Links">
        <P>
          Diese Website enthält Links zu externen Websites (z. B. Google Maps). Für
          den Datenschutz dieser externen Seiten sind wir nicht verantwortlich. Bitte
          informieren Sie sich auf den jeweiligen Seiten über deren Datenschutzrichtlinien.
        </P>
      </Section>

      <Section title="6. Ihre Rechte als betroffene Person">
        <P>
          Sie haben gemäß DSGVO folgende Rechte gegenüber uns als Verantwortlichem:
        </P>
        <P>
          • <strong>Auskunft</strong> (Art. 15 DSGVO) über Ihre gespeicherten Daten<br />
          • <strong>Berichtigung</strong> (Art. 16 DSGVO) unrichtiger Daten<br />
          • <strong>Löschung</strong> (Art. 17 DSGVO) Ihrer Daten<br />
          • <strong>Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)<br />
          • <strong>Widerspruch</strong> (Art. 21 DSGVO) gegen die Verarbeitung<br />
          • <strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO)<br />
          • <strong>Beschwerde</strong> bei der zuständigen Aufsichtsbehörde (Berliner
          Beauftragte für Datenschutz und Informationsfreiheit)
        </P>
        <P>
          Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: kontakt@heilpraxis-spiller.de
        </P>
      </Section>

      <Section title="7. Änderungen dieser Datenschutzerklärung">
        <P>
          Diese Datenschutzerklärung wird bei Bedarf aktualisiert, um rechtliche oder
          technische Änderungen zu berücksichtigen. Stand: Februar 2026.
        </P>
      </Section>
    </Container>
  );
};

export default Datenschutzerklaerung;
